/**
 * RequestDashboard
 *
 * Thin wrapper page providing the Requests tab view. Renders the RequestsPage
 * table and a simple tab header with navigation back to the Company dashboard.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import "./request-dashboard.scss";
import { routes } from "../../constants/routes";
import RequestsPage from "./request/request";

const RequestDashboard: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="request-dashboard">
      <div className="request-dashboard-content">
        <div className="request-dashboard-content-tab">
          <div className="request-dashboard-content-tab-container">
            <button
              className="request-dashboard-content-tab-btn"
              onClick={() => navigate(routes.COMPANYDASHBOARD)}
            >
              Company
            </button>
            <button className="request-dashboard-content-tab-btn request-dashboard-content-tab-active">
              Requests
            </button>
          </div>
        </div>
        <div className="request-dashboard-content-tab-section">
          <RequestsPage />
        </div>
      </div>
    </div>
  );
};

export default RequestDashboard;
